import{useMediaQuery as t}from"@mui/material";import{useTheme as r}from"@mui/material/styles";function o(){const o=r();return t(o.breakpoints.down("lg"))}export{o as default};
